export default "__VITE_ASSET__70fa94b4__"